export default __webpack_public_path__ + "static/media/Amazon2.ba3248e8.webp";